import http from "@/api/http-common";
import {
  getSearchCriteria,
  groupSearchResults,
  sortSearchResults,
} from "@/components/ui/search-results";

const SEARCH_MODE = {
  ALL: 1,
  CODE: 10,
  NAME: 11,
};

export function hasSearchQueryMinimumLength(searchText) {
  return 3 <= getSearchCriteria(searchText).query.length;
}

export function getGroupedSearchResults(stocks, searchText, labels) {
  const sortedStocks = sortSearchResults(stocks, getSearchCriteria(searchText));
  return groupSearchResults(sortedStocks, labels);
}

async function searchApi(store, userType, text, mode) {
  const user = store.getters["getUser"];
  try {
    const res = await http.getApiClient(userType).get("", {
      params: {
        a: "search_ex",
        id: user.id,
        key: user.key,
        text: text ? encodeURIComponent(text) : null,
        mode,
      },
    });
    if (res && 0 === res.data.ec) {
      store.commit("setSearchedStocks", res.data.list);
    }
  } catch (e) {
    console.error(e);
  }
}

export async function performInstrumentSearch(store, userType, searchText) {
  store.commit("setHasItemInSearch", searchText);
  const searchCriteria = getSearchCriteria(searchText);
  if (3 > searchCriteria.query.length) {
    store.commit("setSearchedStocks", []);
    return;
  }

  if ("name" === searchCriteria.mode) {
    await searchApi(store, userType, searchCriteria.query, SEARCH_MODE.NAME);
  } else if ("code" === searchCriteria.mode) {
    await searchApi(store, userType, searchCriteria.query, SEARCH_MODE.CODE);
  } else {
    await searchApi(store, userType, searchCriteria.query, SEARCH_MODE.ALL);
  }
}
